import * as Dialog from '@radix-ui/react-dialog';
import { cn } from '../../lib/utils';
import { useSelector } from 'react-redux';

export function VideoModal({ isOpen, onClose, videoUrl }) {
    console.log("selectedVideoUrl", videoUrl)
    const { darkMode } = useSelector((state) => state.darkMode);

    return (
        <Dialog.Root open={isOpen} onOpenChange={onClose}>
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30" />
            <Dialog.Content className={cn(
                "fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 bg-white rounded-md",
                "dark:bg-gray-800 dark:text-muted"
            )}>
            <div className='flex mb-4 items-center justify-between'>
            
            <Dialog.Title className="text-xl font-bold text-foreground">Video Preview</Dialog.Title>
            <Dialog.Close asChild>
                <button className={cn("rounded-full transition-colors p-1 duration-300 rounded-full bg-gray-100 dark:bg-gray-800 text-foreground","dark:text-gray-100 dark:bg-gray-900 dark:hover:text-gray-100 dark:hover:bg-gray-400")}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            </Dialog.Close>
            </div>
                <Dialog.Description className="mb-4">
                    <video src={videoUrl} controlsList="nodownload" style={{
                        maxWidth: '800px', // Set your desired max width
                        maxHeight: '300px', // Set your desired max height
                        minWidth: '320px',  // Set your desired min width
                        minHeight: '180px'  // Set your desired min height
                    }} controls className="w-full h-auto rounded-md border border-gray-300 dark:border-gray-600" />
                </Dialog.Description>
            </Dialog.Content>
        </Dialog.Root>
    );
}
